import { render, staticRenderFns } from "./FlatDetail.vue?vue&type=template&id=c39e8f66&scoped=true"
import script from "./FlatDetail.vue?vue&type=script&lang=js"
export * from "./FlatDetail.vue?vue&type=script&lang=js"
import style0 from "./FlatDetail.vue?vue&type=style&index=0&id=c39e8f66&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39e8f66",
  null
  
)

export default component.exports